// Module
var code = `<ex-multi-occurrence-maitre-details-ecran lbl-titre="LBL_BLC_URG" multi-occurrence-out="vm.multiOccurrence" multi-occurrence-options="vm.multiOccurrenceOptions"> </ex-multi-occurrence-maitre-details-ecran> `;
// Exports
module.exports = code;